"use strict";
exports.__esModule = true;
exports.unmaskPhone = exports.phoneRegex = exports.formatPhone = void 0;
var formatPhone = function (phone) {
    var numericOnly = phone.replace(/\D/g, '');
    return "(".concat(numericOnly.slice(1, 4), ") ").concat(numericOnly.slice(4, 7), "-").concat(numericOnly.slice(7));
};
exports.formatPhone = formatPhone;
exports.phoneRegex = /^\D?(\d{3})\D?\s?(\d{3})\D?\s?(\d{4})$/;
function unmaskPhone(phone, countryCode) {
    if (countryCode === void 0) { countryCode = 1; }
    var digits = phone.match(/\d/g);
    if (!(digits === null || digits === void 0 ? void 0 : digits.length)) {
        return phone;
    }
    return "".concat(countryCode).concat(digits.join(''));
}
exports.unmaskPhone = unmaskPhone;
